import axios from "axios";
import { Message } from "element-ui";

// 创建 axios 实例
const service = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem("user_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      console.log("🔑 [Request] 携带 Token");
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error("❌ [Request] 请求拦截器错误:", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.code === 200) {
      return res;
    } else {
      Message.error(res.message || "Error");
      return Promise.reject(new Error(res.message || "Error"));
    }
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Message.error("未授权，请重新登录");
          localStorage.removeItem("user_token");
          // router.push('/login')
          break;
        case 403:
          Message.error("拒绝访问");
          break;
        case 404:
          // Message.error("请求的资源不存在");
          break;
        case 500:
          Message.error("服务器内部错误");
          break;
        default:
          Message.error("网络错误，请稍后重试");
      }
    } else {
      // Message.error('网络连接失败')
    }

    return Promise.reject(error);
  }
);

export default service;
